import 'harmony-reflect';
import assembler from '@reduct/assembler';

export default assembler();
